import { ErrorFallbackLayout } from "@/components/errors/ErrorFallbackLayout";
import { ErrorPageContent } from "@/components/errors/ErrorPageContent";

export interface ServerErrorPageProps {
  title?: string;
  description?: string;
  standalone?: boolean;
  variant?: "portal" | "panel";
  homeTo?: string;
  homeLabel?: string;
  onRetry?: () => void;
}

export function ServerErrorPage({
  title = "Erro interno",
  description = "Algo deu errado ao carregar esta pagina. Tente novamente em instantes.",
  standalone = false,
  variant = "portal",
  homeTo = "/",
  homeLabel = "Voltar para a home",
  onRetry,
}: ServerErrorPageProps) {
  const content = (
    <ErrorPageContent
      code="500"
      title={title}
      description={description}
      variant={variant}
      homeTo={homeTo}
      homeLabel={homeLabel}
      onRetry={onRetry ?? (() => window.location.reload())}
    />
  );

  if (standalone) {
    return <ErrorFallbackLayout>{content}</ErrorFallbackLayout>;
  }

  return content;
}
